import React from 'react'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'

const BlockQuote = ({ paddingTop, quote, name }) => {

  return (
    <section className={`block-quote${paddingTop ? ' block-quote--pt' : ''}`}>
      <Fade distance='40px' bottom>
        <div className="block-quote__inner">
          { quote && <blockquote>{parse(quote)}</blockquote> }
          { name && <h5>{ name }</h5> }
        </div>
      </Fade>
    </section>
  );
};

export default BlockQuote;